/**
 * Shared sizing for the Avg / Total pills in report chart headers, so every
 * chart card (Fuel, Energy, Run hours, ...) renders its tags identically.
 *
 * The card is a size container: below TAGS_ROW_MIN_WIDTH the pills use compact
 * sizing; at or above it they get roomier sizing. Chart cards wrap their header
 * in a `containerType: inline-size` box so the container query applies.
 *
 * While the PDF exporter captures a card at its narrow page width it sets
 * {@link CAPTURE_ATTR} on the card, and the `CAPTURE` styles below shrink the
 * header tags and chart text so they fit a half-width page cell.
 */
export const TAGS_ROW_MIN_WIDTH = "560px"
export const WIDE = `@container (min-width: ${TAGS_ROW_MIN_WIDTH})`

/** Set on a chart card by the PDF exporter while it is being captured. */
export const CAPTURE_ATTR = "data-report-capturing"
/** Emotion selector matching a descendant of a card that is being captured. */
export const CAPTURE = `[${CAPTURE_ATTR}] &`

/** Header block min-height during capture, so paired cards' plots line up. */
export const CAPTURE_HEADER_MIN_HEIGHT = "40px"

/**
 * Compact text for the plot area during capture: smaller axis ticks and legend
 * text, so labels fit a half-width page cell without clipping or wrapping.
 */
export const CAPTURE_CHART_TEXT_CSS = {
  [CAPTURE]: {
    ".recharts-cartesian-axis-tick-value": { fontSize: "9px" },
    ".recharts-legend-item-text": { fontSize: "9px" },
  },
} as const

export const PILL_BASE = {
  borderRadius: "9999px",
  whiteSpace: "nowrap",
  fontSize: "11px",
  padding: "2px 7px",
  [WIDE]: { fontSize: "12px", padding: "3px 10px" },
  [CAPTURE]: { fontSize: "8px", padding: "1px 5px" },
} as const

export const AVG_CSS = { ...PILL_BASE, fontWeight: 500, color: "#545454", backgroundColor: "#f2f0ef" } as const
export const TOTAL_CSS = { ...PILL_BASE, fontWeight: 600, color: "#2b2b2b", backgroundColor: "#e6f4f9" } as const
